import React from 'react';
import {
  Checkbox,
  IconButton,
} from 'material-ui';
import CheckIcon from 'material-ui/svg-icons/navigation/check';

const SearchCheckbox = ({
  icon,
  iconColor,
  label,
  iconEl,
  labelSize,
  onToggle,
  style,
  toggled,
}) => (
  <Checkbox
    label={
        icon === 'tc-icon-user-check' ?
        <div
          style={{ marginLeft: '6px', top: '8px', position: 'relative' }}
        >
          <CheckIcon
            color={iconColor}
            style={{ height: '14px' }}
          />
        <span style={{ marginLeft: '8px' }}>{label}</span>
      </div>
      :
      <div
        style={{ marginLeft: '-5px' }}
      >
        {iconEl ? iconEl : (
          <IconButton
            iconClassName={icon}
            iconStyle={{ fontSize: '14px', color: iconColor }}
          />
        )}
        <span style={{ marginLeft: '-5px' }}>{label}</span>
      </div>
    }
    labelStyle={{ width: '100%', marginLeft: '-10px', textAlign: 'left', marginTop: '-8px', height: '20px' }}
    style={style}
    onCheck={onToggle}
    style={{ width: '95%', textAlign: 'center', height: '20px', padding: '2px 0', marginLeft: '8px' }}
    checked={toggled}
  />
);

export default SearchCheckbox;



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/search-widgets/search-checkbox.jsx